import {inject} from "aurelia-framework";
import {Client} from "../api/client";
import {DialogController} from 'aurelia-dialog';
import {FlashService} from "../flash/flash-service";
import moment from 'moment-timezone';
import * as _ from "lodash";
import {FormServiceFactory} from "../form/service/form-service-factory";
import {ConfigurationLoader} from "../form/loader/configuration-loader";
import {BindingSignaler} from "aurelia-templating-resources";

@inject(Client, DialogController, FlashService, ConfigurationLoader, FormServiceFactory, BindingSignaler)
export class FlightSearch {

    constructor(client, dialogController, flash, configurationLoader, formServiceFactory, signaler) {
        this.client = client;
        this.dialogController = dialogController;
        this.flash = flash;
        this.configurationLoader = configurationLoader;
        this.formServiceFactory = formServiceFactory;
        this.signaler = signaler;

        this.submitHandler = this.submit.bind(this);
    }

    onSelectionChangedCallback() {
        return (selectedItems) => {
            this.selectedItems = selectedItems;
        }
    }

    onSelectionReturnChangedCallback() {
        return (selectedItems) => {
            this.returnItems = selectedItems;
        }
    }

    async activate(context) {
        console.log('context', context);
        this.data = context.data;
        this.order = context.order;
        this.title = context.title;
        this.participants = context.participants;

        this.formData = {
            participants: context.participants,
            order: this.order,
        };

        this.selectedItems = [];
        this.returnItems = [];
    }

    _calculateParticipantCount(object) {
        let adultCount = 0;
        let childCount = 0;
        let infantCount = 0;

        let lastDepartureDate = null;

        if (object.itineraries.length > 0) {
            lastDepartureDate = object.itineraries[object.itineraries.length - 1].departureDate;
        }

        for (let participant of this.participants) {

            let birthdate = participant.customer && participant.customer.birthdate ? participant.customer.birthdate : null;

            if (birthdate) {
                let years = moment(lastDepartureDate).diff(moment(birthdate), 'years');

                if (years < 2) {
                    infantCount++;
                } else if (years < 12) {
                    childCount++;
                } else {
                    adultCount++;
                }
            } else {
                adultCount++;
            }
        }

        this.infantCount = infantCount;
        this.childCount = childCount;
        this.adultCount = adultCount;
    }

    async submit({object}) {
        this.loading = true;
        this.searchId = null;

        try {
            this.formData = _.cloneDeep(object);

            this._calculateParticipantCount(object);

            object.childCount = this.childCount;
            object.infCount = this.infantCount;

            if (object.adultCount == null || object.adultCount == 0) {
                object.adultCount = this.adultCount;
            }

            console.log('ABC', this.adultCount, this.participants);

            let data = (await this.client.post('tourism-flight/fare-search', Object.assign(
                {},
                object))).data;

            this.loading = false;

            //Todo error display

            Object.entries(data.errors).forEach((error, key) => {
                this.flash.error('Provider: ' + error[0] + ' - Fehler: ' + error[1]);
            })

            if (!data.searchId && !(Object.entries(data.errors).length > 0)) {
                this.flash.error('Es konnte kein Suchergebnis gefunden werden');
            }

            this.searchId = data.searchId;
            this.hasReturnFlight = data.hasReturnFlight;

        } catch (err) {
            this.loading = false;
            this.searchId = null;

            let error = null;

            if (err && err.data) {
                if (err.data.localizedMessage) {
                    error = err.data.localizedMessage;
                } else if (err.data.message) {
                    error = err.data.message;
                }
            }

            this.flash.error(error || 'Ein unbekannter Fehler ist aufgetreten.');
        }
    }

    back() {
        this.searchId = null;
    }

    ok() {
        if (this.selectedItems.length < 1) {
            this.flash.error('Bitte ein Flugergebnis auswählen');
            return;
        }

        if (this.hasReturnFlight && this.returnItems.length < 1) {
            this.flash.error('Bitte ein Flugergebnis auswählen');
            return;
        }

        this.data.data = {
            fareResult: {
                id: this.selectedItems[0].id,
                modelId: this.selectedItems[0].modelId
            },
        };

        if (this.returnItems && this.returnItems.length === 1) {
            this.data.data.returnResult = {
                id: this.returnItems[0].id,
                modelId: this.returnItems[0].modelId
            };
        }

        const subContingent = this.data?.subContingent;
        const returnSubContingent = this.data?.returnSubContingent;

        if (subContingent?.id) {
            this.data.data.subContingent = {
                id: subContingent.id,
                modelId: subContingent.modelId,
            };
        }

        if (returnSubContingent?.id) {
            this.data.data.returnSubContingent = {
                id: returnSubContingent.id,
                modelId: returnSubContingent.modelId,
            };
        }

        this.dialogController.ok(this.data);
    }
}
